import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
const FormWizardStateContext = React.createContext(null);
const FormWizardStateUpdateContext = React.createContext(null);
export const FormWizardProvider = (props) => {
    const { initialStep, initialLoading, children } = props;
    const [currentStepName, setCurrentStepName] = useState(initialStep);
    const [moving, setmoving] = useState("forward");
    const [loading, setLoading] = useState(initialLoading);
    const [wrapperWidth, setWrapperWidth] = useState(1);
    const [wrapperHeight, setWrapperHeight] = useState(1);
    const [error, setError] = useState();
    const [goBack, setGoBack] = useState();
    const [positionPercent, setPositionPercent] = useState();
    const handleSetCallback = useCallback((callback) => setGoBack({ callback }), [setGoBack]);
    const goToStep = useCallback((step, move) => {
        setmoving(move || "forward");
        setCurrentStepName(step);
    }, []);
    return (_jsx(FormWizardStateContext.Provider, { value: { currentStepName, moving, loading, error, wrapperWidth, wrapperHeight, goBack: goBack?.callback, positionPercent, noToolBar: props.noToolBar, hideMenu: props.hideMenu }, children: _jsx(FormWizardStateUpdateContext.Provider, { value: { goToStep, setLoading, setError, setWrapperWidth, setWrapperHeight, setGoBack: handleSetCallback, setPositionPercent }, children: children }) }));
};
export function useFormWizardState() {
    const data = React.useContext(FormWizardStateContext);
    if (data === undefined) {
        throw new Error('useWizardState must be used within a FormWizardStateContext');
    }
    return data;
}
export function useFormWizardaUpdate() {
    const updateFns = React.useContext(FormWizardStateUpdateContext);
    if (updateFns === undefined) {
        throw new Error('useSwapDataUpdate must be used within a SwapDataProvider');
    }
    return updateFns;
}
